import { combineReducers } from 'redux';

import { applicationReducer } from './application';
import { calculatorReducer } from './calculator';
import { completionReducer } from './completion';
import { consentReducer } from './consent';
import { contextReducer } from './context';
import { errorReducer } from './error';
import { featureReducer } from './feature';
import { kycReducer } from './kyc';
import { loaderReducer } from './loader';
import { ongoingApplicationsReducer } from './ongoingapplications';
import { productsReducer } from './products';
import { SblReducer } from './sbl';
import { stepsReducer } from './steps';
import { userReducer } from './user';
import { vehicleReducer } from './vehicle';

export const rootReducer = combineReducers({
    ongoingApplications: ongoingApplicationsReducer,
    application: applicationReducer,
    completion: completionReducer,
    calculator: calculatorReducer,
    products: productsReducer,
    vehicle: vehicleReducer,
    context: contextReducer,
    consent: consentReducer,
    loader: loaderReducer,
    sbl: SblReducer,
    steps: stepsReducer,
    error: errorReducer,
    user: userReducer,
    kyc: kycReducer,
    feature: featureReducer,
});

export type AppState = ReturnType<typeof rootReducer>;

export default { rootReducer };
